// Inline curtain card â€” Open / Stop / Close right on the grid card (no window).
// Commands OPENCURTAIN / STOPCURTAIN / CLOSECURTAIN (matches the Flutter app).

import React from 'react';
import { Card, Box, Typography, Button } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import StopIcon from '@mui/icons-material/Stop';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useApp } from '../../../core/state/AppContext';
import { publishCommand } from '../../../core/utils/deviceController';
import DeviceStatusDot from './DeviceStatusDot';
import DeviceCardMenu from './DeviceCardMenu';

export default function CurtainControlCard({ device, subtitle }) {
  const { userId } = useApp();
  const uno = device.UniqueNumber;
  const send = (cmd) => publishCommand(uno, cmd, userId);

  return (
    <Card sx={{ p: 1.25, borderRadius: 3, height: '100%', display: 'flex', flexDirection: 'column', gap: 0.75, bgcolor: 'background.paper', border: 1, borderColor: 'divider' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          {subtitle && (
            <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block', lineHeight: 1.2 }}>{subtitle}</Typography>
          )}
          <Typography fontWeight={700} color="text.primary" noWrap>{device.DeviceName || uno}</Typography>
        </Box>
        <DeviceStatusDot device={device} />
        <DeviceCardMenu device={device} />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 'auto' }}>
        <Button variant="contained" startIcon={<ArrowUpwardIcon />} onClick={() => send('OPENCURTAIN')}>Open</Button>
        <Button variant="outlined" startIcon={<StopIcon />} onClick={() => send('STOPCURTAIN')} sx={{ color: 'text.primary', borderColor: 'divider' }}>Stop</Button>
        <Button variant="contained" startIcon={<ArrowDownwardIcon />} onClick={() => send('CLOSECURTAIN')}>Close</Button>
      </Box>
    </Card>
  );
}
